import { useMyStore } from "~/stores/myStore"

export default defineNuxtRouteMiddleware((to, from) => {
    const myStore = useMyStore()

    let pathsPermitidosSemLogin = [
      '/login',
      '/pesquisador/cadastrarseNaPlataforma',
      '/pesquisador/termosDeUso',
      '/pesquisador/politicaPrivacidade',
      '/responder',
      '/obrigado',
      //'/respondente/tcle',
    ]

    //urls que só devem aparecer quando não está logado.
    if (pathsPermitidosSemLogin.find((x) => x == to.path)) {
      if (myStore.estaLogado) {
        return navigateTo('/')
        /*if (myStore.dadosLogin.Perfil == 'Respondente') {
          if (to.path != '/responder')
            return navigateTo('/responder')
        }
        else
          return navigateTo('/')*/
      }
        
    } else {
      //todas as outras urls devem direcionar para o login, se não estiver logado.
      if (!myStore.estaLogado)
        return navigateTo('/login')
    }


    //tratamento para retornar o respondente para resposta do questionário,
    //caso ele resolva voltar para a home.
    const ehRespondente = myStore.dadosLogin?.Perfil == 'Respondente'
    if (ehRespondente && to.path == '/') {
      let ultimaPesquisaRespondida = myStore.ultimaPesquisaRespondente?.pesquisa
      let questionarioReferencia = ultimaPesquisaRespondida?.QuestionarioReferencia
      
      switch (questionarioReferencia) {
        case 'SCREENER':
          return navigateTo('/responder/responderScreener')
        case 'QFA':
          return navigateTo('/responder/responderQFA')
        case 'R24H':
          return navigateTo('/responder/responderR24H')
        default:
          return navigateTo('/obrigado')
      }

    }

  })
  